<template>
  <div class="index">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <!-- banner -->
      <swiper-slide class="swiper-slide">
        <!-- nav -->
        <Navbar style="height: 12%" />
        <el-carousel height="100%" id="top">
          <el-carousel-item class="banner">
            <video
              src="https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/banner1.mp4"
              controls="controls"
              autoplay="autoplay"
              muted
              loop
            ></video>
          </el-carousel-item>
          <el-carousel-item
            v-for="(item, index) in bannerList"
            :key="index"
            class="banner"
          >
            <router-link
              :to="{ path: '/productDetail', query: { id: item.id } }"
              style="display: block"
            >
              <img :src="item.imgurl" alt="" />
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </swiper-slide>
      <!-- product -->
      <swiper-slide class="swiper-slide">
        <section
          class="product_box1"
          style="height: 62%; padding-top: 1.5%; margin-top: 0"
        >
          <ul>
            <li>
              <router-link :to="{ path: '/product', query: { name: 0 } }">
                <p>旗舰奢华按摩椅系列</p>
                <img src="@/assets/images/home_icon1.png" alt="" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 1 } }">
                <p>时尚简约按摩椅系列</p>
                <img src="@/assets/images/home_icon2.png" alt="" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 2 } }">
                <p>超值舒享按摩椅系列</p>
                <img src="@/assets/images/home_icon3.png" alt="" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 3 } }">
                <p>8推全功能按摩椅系列</p>
                <img src="@/assets/images/home_icon4.png" alt="" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 4 } }">
                <p>眼部按摩器系列</p>
                <img src="@/assets/images/home_icon5.png" alt="" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 5 } }">
                <p>小件按摩器系列</p>
                <img src="@/assets/images/home_icon6.png" alt="" />
              </router-link>
            </li>
          </ul>
          <div class="product_box2">
            <video
              src="https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/banner2.mp4"
              controls="controls"
            />
            <section
              style="
                height: 48.5%;
                display: flex;
                justify-content: space-between;
                margin-top: 1%;
              "
            >
              <router-link
                :to="{ path: '/productDetail', query: { id: 3 } }"
                class="img1"
              >
                <img src="@/assets/images/product1.png" alt="" />
              </router-link>
              <router-link
                :to="{ path: '/productDetail', query: { id: 2 } }"
                class="img1"
              >
                <img src="@/assets/images/product3.png" alt="" />
              </router-link>
              <router-link
                :to="{ path: '/productDetail', query: { id: 8 } }"
                class="img1"
              >
                <img src="@/assets/images/product4.png" alt="" />
              </router-link>
            </section>
          </div>
        </section>
      </swiper-slide>
      <!-- active -->

      <swiper-slide class="swiper-slide">
        <section class="active">
          <div class="active1">
            <section>
              <a
                target="_blank"
                href="https://news.sina.com.cn/sx/2022-11-14/detail-imqqsmrp6097722.shtml"
              >
                <img src="@/assets/images/active1.png" alt="" />
                <div class="box">
                  <p>摩摩哒 X 成都AG超玩会</p>
                </div>
              </a>
            </section>
            <section>
              <a
                target="_blank"
                href="https://k.sina.com.cn/article_5601071106_14dd99002001016ivk.html?kdurlshow=1&wm=3049_0047&from=game"
              >
                <img src="@/assets/images/active2.png" alt="" />
                <div class="box">
                  <p>摩摩哒 X 王者荣耀</p>
                </div>
              </a>
            </section>
          </div>
          <div class="active2">
            <section>
              <a
                href="https://mp.weixin.qq.com/s/ZCy4GSw237imYu5Ms7eoWA"
                target="_blank"
              >
                <img src="@/assets/images/active3.png" alt="" />
                <div class="box">
                  <p>摩摩哒 X《给你我的名片2》</p>
                </div>
              </a>
            </section>
            <section>
              <a
                href="http://pingquan.jiaju.sina.com.cn/zixun/q/20220714/6953274609156555924.shtml"
                target="_blank"
              >
                <img src="@/assets/images/active4.png" alt="" />
                <div class="box">
                  <p>摩摩哒 X《玩美咖》</p>
                </div>
              </a>
            </section>
            <section>
              <router-link :to="{ path: '/active', query: { id: 2 } }">
                <img src="@/assets/images/active5.png" alt="" />
                <div class="box">
                  <p>摩摩哒 X 达人种草</p>
                </div>
              </router-link>
            </section>
          </div>
        </section>
      </swiper-slide>
      <!-- foot -->
      <swiper-slide class="swiper-slide">
        <div class="con_info">
          <h2>门店查找</h2>
        </div>
        <!-- 地图 -->
        <div class="mapbox">
          <!-- 搜索容器 -->
          <div class="mapsearch" id="rResult">
            <div class="SEarch">
              <el-input placeholder="请输入您想搜索的城市名" v-model="Search">
              </el-input>
              <i
                class="el-icon-circle-close close"
                v-if="Search"
                @click="Search = ''"
              ></i>
              <i class="el-icon-search searchIcon" @click="searchPlaces()"></i>
            </div>
            <!-- 数据容器 -->
            <div class="mapresult">
              <ul>
                <li
                  :class="listAct === index ? 'on' : ''"
                  v-for="(item, index) in results"
                  :key="index"
                  @click="selectPlace(item, index)"
                >
                  <div class="num">{{ index + 1 }}</div>
                  <div>
                    <p>
                      {{ item.store_name }}
                    </p>
                    <p>
                      <img src="@/assets/images/icon_locate.png" alt="" />
                      {{ item.address }}
                    </p>
                    <p>
                      <img src="@/assets/images/icon_phone.png" alt="" />
                      {{ item.phone }}
                    </p>
                  </div>
                </li>
                <p class="none" v-if="results.length == 0">
                  搜索结果暂无门店信息
                </p>
              </ul>
            </div>
          </div>
          <!-- 地图渲染 -->
          <div class="mapshow">
            <div id="map" style="width: 100%; height: 100%"></div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <Foot />
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { store_list } from "@/request/http";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Navbar from "@/components/nav.vue";
import Foot from "@/components/indexFoot.vue";
import { bannerList } from "@/assets/js/data.js";
export default {
  name: "index",
  components: {
    Navbar,
    Foot,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      routeName: "",
      bannerList: bannerList,
      list: [], //轮换列表
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;
            console.log(swiper.activeIndex); //滑动打印当前索引
            if (swiper.activeIndex === this.list.length - 1) {
              //到最后一个加载更多数据
              let newList = [];
              let listLength = this.list.length;
              for (let i = 0; i < 10; i++) {
                newList.push(listLength + i);
              }
              this.list = this.list.concat(newList);
            }
          },
        },
      },
      listAct: null,
      Search: "", //搜索
      local: "",
      BMap: "",
      map: null,
      places: [],
      selectedPlace: null,
      showInfoWindow: false,
      infoWindowStyle: {
        position: "absolute",
        zIndex: 1000,
      },
      results: [],
    };
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    $route() {
      if (this.$route.query.name == undefined) {
        document.getElementById("top").scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    this.routeName = this.$route.name;
    if (this.routeName == undefined) {
      document.getElementById("top").scrollIntoView({ behavior: "smooth" });
    }
    const checkBMap = setInterval(() => {
      if (window.BMap) {
        clearInterval(checkBMap);
        this.initMap();
      }
    }, 100);
    this.addMapEventListeners();
  },
  methods: {
    addMapEventListeners() {
      const mapElement = document.getElementById("rResult");
      // 阻止 Swiper 处理 pointermove 事件
      mapElement.addEventListener("pointermove", (event) => {
        console.log(event);
        event.stopPropagation(); // 阻止事件传播
      });
      // 阻止 Swiper 处理 mousewheel 事件
      mapElement.addEventListener("wheel", (event) => {
        event.stopPropagation(); // 阻止事件传播
      });
    },
    initMap() {
      this.map = new BMap.Map("map", { enableMapClick: false });
      // this.map.enableScrollWheelZoom(true);

      this.map.centerAndZoom("上海", 12);
      store_list().then((res) => {
        console.log(res);
        this.results = res.data.data;
        this.map.clearOverlays();
        this.results.forEach((item) => {
          this.addMarker(item); // 为每个搜索结果添加标注
        });
      });
    },
    searchPlaces() {
      store_list({ search: this.Search }).then((res) => {
        this.results = res.data.data;
        if (this.Search == "") {
          this.map.centerAndZoom("上海", 12);
        }
        if (this.results.length == 0 && this.Search !== "") {
          this.map.centerAndZoom(this.Search, 12);
        }
      });
    },
    addMarker(place) {
      var point = new BMap.Point(place.longitude, place.latitude);
      var dialog =
        '<div class="info-window"><h3>' +
        place.store_name +
        "</h3><p><span>地址：</span><span>" +
        place.address +
        "</span></p><button id='endAddress' >到这去<span class='locat'></span></button>";
      var dia = new BMap.InfoWindow(dialog);
      const marker = new BMap.Marker(point);
      this.map.addOverlay(marker);
      this.map.panTo(point);
      marker.addEventListener("click", () => {
        this.selectedPlace = {
          title: place.title,
          address: place.address,
          point: point,
        };
        this.map.openInfoWindow(dia, point);
        const element = document.getElementById("endAddress");
        element.addEventListener("click", () => {
          const url = `http://api.map.baidu.com/marker?location=${place.latitude},${place.longitude}&title=${place.store_name}&content=${place.address}&output=html`;
          window.open(url, "_blank"); // 在新窗口打开百度地图
        });
      });
    },
    selectPlace(place, i) {
      var point = new BMap.Point(place.longitude, place.latitude);
      var dialog =
        '<div class="info-window"><h3>' +
        place.store_name +
        "</h3><p><span>地址：</span><span>" +
        place.address +
        "</span></p><button id='endAddress' >到这去<span class='locat'></span></button>";
      var dia = new BMap.InfoWindow(dialog);
      this.map.openInfoWindow(dia, point);
      this.map.panTo(point);
      this.listAct = i;
      this.selectedPlace = {
        title: place.title,
        address: place.address,
        point: point,
      };
      const element = document.getElementById("endAddress");
      element.addEventListener("click", () => {
        const url = `http://api.map.baidu.com/marker?location=${place.latitude},${place.longitude}&title=${place.store_name}&content=${place.address}&output=html`;
        window.open(url, "_blank"); // 在新窗口打开百度地图
      });
    },
  },
};
</script>
<style type="text/css">
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
.info-window {
  display: flex;
  flex-direction: column;
  width: 384px;
  position: absolute;
  z-index: 1000;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 3px 12px #a3a8b721;
  padding: 20px;
}
.BMap_center {
  width: 384px;
}
.info-window h3 {
  font-size: 20px;
  line-height: 28px;
  color: #333;
}
.info-window p {
  font-size: 17px;
  line-height: 24px;
  color: #666;
  margin: 8px 0 16px;
  display: flex;
}
.info-window p span:first-child {
  white-space: nowrap;
}
.info-window p span {
  display: block;
}
.info-window button {
  width: 157px;
  height: 44px;
  mix-blend-mode: normal;
  border-radius: 12px;
  background: #222222;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  line-height: 24px;
  box-sizing: border-box;
  cursor: pointer;
  padding-left: 20px;
}
.info-window p img {
  width: 26px;
  height: 26px;
  margin-left: 4px;
}
.info-window p img.black {
  display: none;
}
.info-window button:hover {
  border: 2px solid #222222;
  background: #ffffff;
  color: #222222;
}
.info-window p img.white {
  display: none;
}
.info-window p img.black {
  display: block;
}
.locat {
  background: url("../assets/images/icon_locate2.png") no-repeat 100%;
  display: block;
  height: 30px;
  width: 30px;
}
.info-window button:hover .locat {
  background: url("../assets/images/icon_locate.png") no-repeat 100%;
}
/*地图标题 infoWindow*/
.BMap_bubble_title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  background: transparent !important;
}

.BMap_pop .BMap_top {
  background: rgba(0, 0, 0, 0) !important;
  border: 0 !important;
}

.BMap_pop .BMap_center {
  width: 281px !important;
  border: 0 !important;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop .BMap_bottom {
  border: 0 !important;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(3) {
  background: transparent !important;
}

.BMap_pop div:nth-child(3) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(1) {
  /* border-radius: 3px 0 0 0;
  background: transparent !important; */
  border: 0 !important;
}
.BMap_pop div:nth-child(8) {
  display: none !important;
}
.BMap_pop div:nth-child(9) {
  overflow: visible !important;
}
.BMap_pop div:nth-child(1) div {
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(5) {
  border-radius: 0 0 0 3px;
  background: transparent !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(5) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(7) {
  background: transparent !important;
  left: 226px;
}

.BMap_pop div:nth-child(7) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop img {
  display: none;
}
.BMap_shadow {
  display: none !important;
}
.el-carousel__indicators--horizontal {
  bottom: 3rem !important;
}
.el-carousel__indicator.is-active button {
  background: #468de9;
}

.el-carousel__button {
  width: 1rem !important;
  height: 1rem !important;
  border-radius: 100%;
  background-color: #fff;
}
.el-carousel__container {
  height: auto;
}
.product_box2 {
  width: 64%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
.index {
  width: 100%;
  #top {
    height: 88%;
  }
  .banner {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product_box1 {
    // width: 100%;
    width: 80%;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ul {
      width: 35%;
      height: 100%;
      li {
        height: 22.8%;
        display: flex;
        align-items: center;
        background: #f5bf4a;
        margin-bottom: 3.1%;
        a {
          color: #fff;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 70%;
          margin: 0 auto;
          flex-wrap: nowrap;
          p {
            font-size: 1.5rem;
            letter-spacing: 1px;
          }
          img {
            width: 6rem;
            // margin-left: 1rem;
          }
        }
      }
    }
    .img1 {
      width: 32.2%;
      height: 100%;
      background: #e5e5e5;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // .imgW {
    //   width: 35%;
    // }
  }
  .active {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      section {
        position: relative;
        z-index: 1;
        height: 100%;
        .box {
          display: none;
        }
      }
      > section:hover .box {
        display: block;
        position: absolute;
        top: 1rem;
        left: 1rem;
        // width: 15rem;
        height: 2rem;
        line-height: 2rem;
        padding: 1rem 2rem;
        background-color: rgba(0, 0, 0, 0.5);
        // border: 1px solid rgba(187, 187, 187, 1);
        p {
          text-align: center;
          font-size: 1.5rem;
          color: #fff;
        }
      }
    }
    .active1 {
      height: 43%;
      padding-top: 2%;
      section {
        width: 49.5%;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .active2 {
      margin-top: 1rem;
      height: 50%;
      section {
        width: 32.5%;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.con_info {
  padding-top: 1%;
  width: 80%;
  margin: 0 auto;
  h2 {
    color: #101010;
  }
}
#container {
  overflow: hidden;
  width: 100%;
  height: 836px;
  // margin: 0 auto;
  font-family: "微软雅黑";
}
.mapbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 80%;
  height: 100%;
  margin: 0 auto;
  padding-top: 1%;
  position: relative;
  .mapsearch {
    width: 614px;
    height: 88%;
    min-width: 30%;
    margin-right: 20px;
    border-radius: 20px;
    background: #f6f6f6;
    overflow: hidden;
    pointer-events: auto;
    .SEarch {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      margin: 40px 24px;
      /deep/.el-input {
        border-radius: 16px;
        padding-right: 100px;
        background: #fff;
      }
      /deep/.el-input__inner {
        height: 68px;
        font-size: 20px;
        border: 0;
        border-radius: 16px;
        padding-right: 10px;
      }
      .searchIcon {
        position: absolute;
        right: 1px;
        font-size: 28px;
        font-weight: bold;
        color: #666;
        cursor: pointer;
        display: block;
        padding: 19px;
        top: 1px;
        background: #fff;
        border-radius: 16px;
      }
      .close {
        position: absolute;
        right: 66px;
        background: #fff;
        cursor: pointer;
        font-weight: bold;
        color: #999;
        font-size: 24px;
      }
    }
    .mapresult {
      margin-top: 32px;
      height: 81%;
      overflow-y: scroll;
      .none {
        padding-left: 24px;
        color: #b6bbc2;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        margin-top: 40%;
      }
      ul li {
        cursor: pointer;
        padding: 24px;
        display: flex;
        //justify-content: space-between;
        color: #333;
        font-size: 20px;
        line-height: 28px;
        .num {
          margin-right: 24px;
        }
        p {
          display: flex;
          //align-items: center;
          img {
            width: 26px;
            height: 26px;
            margin-right: 6px;
          }
        }
        p:nth-child(2) {
          margin: 16px 0;
        }
      }
      ul li:hover {
        background: #eeeff0;
      }
      ul li.on {
        background: #eeeff0;
      }
      // height: 400px;
      // overflow: auto;
    }
  }
  .mapshow {
    width: 100%;
    position: relative;
    height: 88%;
  }

  .info-window {
    display: flex;
    flex-direction: column;
    width: 384px;
    position: absolute;
    z-index: 1000;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 3px 12px #a3a8b721;
    padding: 20px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #333;
    }
    p {
      font-size: 17px;
      line-height: 24px;
      color: #666;
      margin: 8px 0 16px;
      display: flex;
      span:first-child {
        white-space: nowrap;
      }
      span {
        display: block;
      }
    }
    button {
      width: 157px;
      height: 44px;
      mix-blend-mode: normal;
      border-radius: 12px;
      background: #222222;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      line-height: 24px;
      box-sizing: border-box;
      cursor: pointer;
      padding-left: 20px;
      img {
        width: 26px;
        height: 26px;
        margin-left: 4px;
      }
      img.black {
        display: none;
      }
    }
    button:hover {
      border: 2px solid #222222;
      background: #ffffff;
      color: #222222;
      img.white {
        display: none;
      }
      img.black {
        display: block;
      }
    }
  }
}
video {
  width: 100%;
  // object-fit: fill;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}
</style>
